import { useContext } from "react";

import AgentHandlerLinkModalContext, {
  AgentHandlerLinkModalContextState,
} from "./AgentHandlerLinkModalContext";

const useAgentHandlerLinkModalContext = (): AgentHandlerLinkModalContextState =>
  useContext(AgentHandlerLinkModalContext);

export default useAgentHandlerLinkModalContext;
